import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalComponent } from 'remarketing-ui-components-lib';
import { GENERAL_ERROR_MESSAGE } from '@ally/remarketing/shared/errors';
import { AuctionSummaryService, PurchasedItemDto, PurchaseReportEmailRequestDto, ReportType } from 'remarketing-angular-library';
import { ActionSubmittedContentModalComponent } from '../action-submitted-content-modal/action-submitted-content-modal.component';
import { ReportUtilityService } from '../../services/report-utility.service';
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
import { SaComponent } from 'smartauction-frontend-micro-library';
import { take, takeUntil } from 'rxjs/operators';

import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-email-modal',
    templateUrl: './email-modal.component.html',
    styleUrls: ['./email-modal.component.scss'],
    imports: [TranslocoDirective, ModalComponent, FormsModule, ActionSubmittedContentModalComponent]
})
export class EmailModalComponent extends SaComponent implements OnInit {
  @ViewChild(ModalComponent) modal: ModalComponent;
  @ViewChild(ActionSubmittedContentModalComponent) actionSubmittedModal: ActionSubmittedContentModalComponent;

  @Input() purchasedItems: PurchasedItemDto[];
  @Input() reportType: ReportType = null;
  @Input() reportList: ReportType[];
  @Input() modalId = 'email-modal';
  email: string;
  emailTo: string[];
  errorMessage: string | ((val: string | number) => string);
  submittedModalContent: string;

  isSubmitting = false;
  toInvalidAddress = false;
  noAddress = false;
  translatedMsgs: any;

  constructor(
    private readonly _auctionSummaryService: AuctionSummaryService,
    private readonly _reportUtilityService: ReportUtilityService,
    private readonly translocoService: TranslocoService
  ) {
    super();
  }

  ngOnInit() {
    this.getTranslations();
  }

  getTranslations(): void {
    this.translocoService.selectTranslateObject('reports.emailModal').pipe(takeUntil(this.destroyed$)).subscribe(value => {
      this.translatedMsgs = value;
    });
  }

  show() {
    this.errorMessage = '';
    this.isSubmitting = false;
    this.modal.show();
  }

  sendEmail() {
    if (this.isSubmitting) { return; }
    this.errorMessage = '';
    if (this.validateEmail()) {
      this.errorMessage = this.translatedMsgs.errorMsg;
    } else {
      this.isSubmitting = true;
      const emails = this.emailTo.map(email => email.trim()).join(', ');
      const purchaseReportEmailRequest: PurchaseReportEmailRequestDto = this._reportUtilityService.createPurchaseReportEmailRequest(
        this.purchasedItems,
        this.reportType,
        this.emailTo,
        this.reportList,
      );
      this._auctionSummaryService.viewPurchasedItemReportsEmail(purchaseReportEmailRequest).pipe(take(1)).subscribe(
        response => {
          this.isSubmitting = false;
          this.submittedModalContent = `${this.translatedMsgs.successMsg} ${emails}.`;
          this.modal.close();
          this.actionSubmittedModal.show();
        },
        error => {
          this.isSubmitting = false;
          this.errorMessage = error.error.errors[0].code;
        }
      );
    }
  }

  validateEmailAddress(emailAddress: string) {
    const validEmailExpression =
      // tslint:disable-next-line: max-line-length
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return emailAddress.match(validEmailExpression);
  }

  validateEmailAddressList(addressList: string[]) {
    const badAddress = [];
    for (const address of addressList) {
      if (!this.validateEmailAddress(address.trim())) {
        badAddress.push(address);
      }
    }
    return badAddress;
  }

  cleanErrorBoolean() {
    this.noAddress = false;
    this.toInvalidAddress = false;
  }

  validateEmail() {
    this.cleanErrorBoolean();
    this.emailTo = [];

    if (this.email !== undefined && this.email.length > 0) {
      this.emailTo = this.email.split(',');
      const toBadAddress = this.validateEmailAddressList(this.emailTo);
      if (toBadAddress.length > 0) {
        this.toInvalidAddress = true;
      }
    }
    if (this.emailTo.length === 0) {
      this.noAddress = true;
    }
    return this.toInvalidAddress || this.noAddress;
  }

  setErrorResponse(errorText = this.translatedMsgs.errorMsg) {
    this.errorMessage = errorText;
  }

  cancel() {
    this.modal.close();
  }
}
